import { getErrorStatus } from './getErrorStatus';

/** Tries in total, including the first. */
export const MAX_WRITE_ATTEMPTS = 3;

/**
 * Whether a failed write is worth sending again.
 *
 * Only what a second attempt could plausibly fix: a transport failure, which
 * carries no status at all, or the server saying it went wrong. A 4xx is a
 * decision -- the event is gone, the caller is not allowed, the slot is taken --
 * and repeating it three times only fails slower while the user watches a
 * spinner.
 *
 * The distinction is load-bearing rather than tidy. Of the 18 joins that
 * produced no invite against an event that still exists, some are transient and
 * the rest are not; retrying the second group is how a silent failure becomes a
 * slow silent failure.
 */
export function shouldRetryWrite(failureCount: number, error: unknown) {
  if (failureCount >= MAX_WRITE_ATTEMPTS) {
    return false;
  }

  const status = getErrorStatus(error);

  return status === undefined || status >= 500;
}

/** 500ms, 1s, 2s -- long enough to outlast a blip, short enough to sit through. */
export function writeRetryDelay(attempt: number) {
  return 500 * 2 ** attempt;
}
